<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="add"
      >新增</a-button
    >
    <a-modal v-model="visible" centered title="添加员工" @ok="handleOk">
      <p>姓名</p>
      <a-input v-model="form.name"></a-input>
      <p>员工号</p>
      <a-input v-model="form.salesman"></a-input>
      <p>失效时间（分为单位）</p>
      <a-input
        type="number"
        @blur="updateTime($event)"
        v-model="form.availableTime"
      ></a-input>
    </a-modal>
    <a-modal v-model="visibletwo" centered title="编辑员工" @ok="handleOktwo">
      <p>姓名</p>
      <a-input v-model="forms.name"></a-input>
      <p>员工号</p>
      <a-input v-model="forms.salesman"></a-input>
      <p>失效时间（分为单位）</p>
      <a-input
        type="number"
        @blur="updateTimes($event)"
        v-model="forms.availableTime"
      ></a-input>
    </a-modal>
    <a-modal
      v-model="ifImg"
      title="员工二维码"
      @ok="handleQC(operate)"
      cancelText="取消"
      okText="确定"
    >
      <div>
        <el-button @click="downloadCodeImg()">点击下载二维码</el-button>
      </div>
      <img
        :src="img"
        style="width: 200px; height: 200px; margin-left: 100px"
        alt=""
      />
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="record => record.orderNo"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="edit(operate)">编辑</a>
        <a href="javascript:;" v-on:click.prevent="showImg(operate)">
          推广小程序码
        </a>
        <a href="javascript:;" @click="del(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  getStaffImg,
  staffList,
  staffAddAccount,
  staffEditAccount,
  staffDelAccount
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "员工ID",
    dataIndex: "id",
    align: "center",
    scopedSlots: { customRender: "id" }
  },
  {
    title: "姓名",
    dataIndex: "name",
    align: "center",
    scopedSlots: { customRender: "name" }
  },
  {
    title: "员工号",
    dataIndex: "salesman",
    align: "center",
    scopedSlots: { customRender: "salesman" }
  },
  {
    title: "失效时间",
    dataIndex: "availableTime",
    align: "center",
    scopedSlots: { customRender: "availableTime" }
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" }
  }
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: total => `共 ${total} 条`,
        pageSize: 10
      },
      loading: false,
      columns,
      img: "",
      ifImg: false,
      visible: false,
      visibletwo: false,
      limit: 10,
      page: 1,
      form: {
        name: "",
        salesman: "",
        availableTime: ""
      },
      forms: {
        id: "",
        name: "",
        salesman: "",
        availableTime: ""
      }
    };
  },
  mounted() {
    this.getData();
  },
  props: ["formInline"],
  methods: {
    updateTime(e) {
      let num = e.target.value || 0;
      this.form.availableTime = num < 1 ? 1 : parseInt(num);
    },
    updateTimes(e) {
      let num = e.target.value || 0;
      this.forms.availableTime = num < 1 ? 1 : parseInt(num);
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      staffList({ limit: 10, page: this.pagination.current }).then(res => {
        this.data = res.data;
        this.loading = false;
      });
    },
    edit(row) {
      this.visibletwo = true;
      this.forms.id = row.id;
      this.forms.name = row.name;
      this.forms.salesman = row.salesman;
      this.forms.availableTime = row.availableTime;
    },
    handleQC(e) {
      this.ifImg = false;
    },
    showImg(row) {
      console.log("showImg:", row);
      this.ifImg = true;
      getStaffImg(row.salesman).then(res => {
        this.img = res.data;
        console.log("showImg res ------", res);
      });
    },
    // 下载图片
    downloadCodeImg() {
      console.log("下载图片");
      var a = document.createElement("a");
      a.download = name || "pic";
      // 设置图片地址
      a.href = this.img;
      a.click();
    },
    // 查询
    query() {
      this.loading = true;
      staffList(this.formInline).then(res => {
        this.pagination.total = res.count;
        this.data = res.data;
        this.loading = false;
      });
    },
    del(row) {
      this.loading = true;
      staffDelAccount(row.id).then(res => {
        this.loading = false;
        this.getData();
        message.success(res.info);
      });
    },
    add() {
      this.visible = true;
      this.form = {};
    },
    handleOk() {
      if (!this.form.name) {
        message.warning("姓名不能为空");
        return;
      }
      if (!this.form.salesman) {
        message.warning("员工号不能为空");
        return;
      }
      if (!this.form.availableTime) {
        message.warning("失效时间不能为空");
        return;
      }
      this.visible = false;
      staffAddAccount(this.form).then(res => {
        message.success(res.info);
        this.getData();
        this.form = {};
      });
    },
    handleOktwo() {
      if (!this.forms.name) {
        message.warning("姓名不能为空");
        return;
      }
      if (!this.forms.salesman) {
        message.warning("员工号不能为空");
        return;
      }
      if (!this.forms.availableTime) {
        message.warning("失效时间不能为空");
        return;
      }
      this.visibletwo = false;
      staffEditAccount(this.forms).then(res => {
        message.success(res.info);
        this.getData();
      });
    },
    getData() {
      staffList({ page: 1, limit: 10 }).then(res => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    }
  }
};
</script>
<style scoped>
img {
  width: 110px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/storeManagement/staffManagement/staffContent.vue